import { HiverAxios, showMessage } from 'h-commons';
import { SET_FOOTER_TEXT } from './types';
import { CreateApiHandler } from '../../common/helpers/thunkMiddleware';

export const updateFooterText = CreateApiHandler((footerText) => {
    let url = '/api/account/footer/update';

    return new Promise((res, rej) => {
        HiverAxios({
            url: url,
            type: 'PUT',
            params: { footer_text: footerText },
            callback: response => {
                const { success, message } = response.data;
                if (success) {
                    res({ footer_text: footerText });
                    showMessage({ message: "Email footer settings edited", type: 'success' });
                }
                else {
                    rej(message);
                }
            },
            onfail: (err) => {
                rej(err.data?.message || 'Something went wrong');
            }
        });
    });
}, SET_FOOTER_TEXT, { errorMessage: "Failed to edit Email footer settings" });